module.exports = __webpack_public_path__ + "static/media/testimonial (3).c861cccf.png";